<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Desde"
            label-for="fechaDesde"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="fechaDesde" 
              v-model="filtro.fechaDesde" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Hasta"
            label-for="fechaHasta"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="fechaHasta" 
              v-model="filtro.fechaHasta" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Proveedor"
            label-for="proveedor"
            :label-cols="labelCols"
            horizontal>
            <b-input-group>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="seleccionarProveedor">
                <b-input-group-text>
                  <i :class="{ 'fa fa-search': !filtro.proveedor,
                                'fa fa-remove': filtro.proveedor  }"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="proveedor"
                :value="proveedorNombre"
                readonly
                type="text"/>
            </b-input-group>
          </b-form-group>  
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>

    <b-modal ref="searchProveedorModal" 
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        :incluirInactivos="true"
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>
  </div>
</template>

<script>
import SearchProveedor from '../proveedores/SearchList.vue';
import moment from 'moment';

export default {
  components: {
    appSearchProveedor: SearchProveedor,
  },
  props: {
    fechaDesde: {
      type: String,
      default: ''
    },
    fechaHasta: {
      type: String,
      default: ''
    },
    proveedor: {
      type: Object,
      default: null
    },
    sortByDescending: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      filtro: {
        fechaDesde: '',
        fechaHasta: '',
        proveedor: null,
        sortByDescending: false
      },

      labelCols: 2,
      showOpcionesFiltro: false
    }
  },
  created() {
    this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD');
    this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');
    this.filtro.proveedor = this.proveedor;
    this.filtro.sortByDescending = this.sortByDescending;
  },
  computed: {
    'proveedorNombre': function() {
      return this.filtro.proveedor? this.filtro.proveedor.nombre.trim() : '';
    },
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.proveedor = null;
    },
    seleccionarProveedor() {
      if (this.filtro.proveedor) {
        this.filtro.proveedor = null;
      } else {
        this.$refs.searchProveedorModal.show();
      }
    },
    proveedorSeleccionado(proveedor) {
      this.filtro.proveedor = proveedor;
      this.$refs.searchProveedorModal.hide();
    },
  },
}
</script>

<style>
</style>
